/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { AuthorizationResponseMobileDto, CreateAuthorizationRequestDto } from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class MobileAuthorizationV2Controller<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags mobile-authorization-v-2-controller
   * @name FindAuthorizationRequestForMobile
   * @request GET:/api/v2/m/authorization/request
   */
  findAuthorizationRequestForMobile = (params: RequestParams = {}) =>
    this.http.request<AuthorizationResponseMobileDto, any>({
      path: `/v2/m/authorization/request`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static findAuthorizationRequestForMobilePath = '/v2/m/authorization/request'
  static findAuthorizationRequestForMobileMethod = 'GET'
  /**
   * No description
   *
   * @tags mobile-authorization-v-2-controller
   * @name CreateAuthorizationRequestForMobile
   * @request POST:/api/v2/m/authorization/request
   */
  createAuthorizationRequestForMobile = (
    data: CreateAuthorizationRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<AuthorizationResponseMobileDto, any>({
      path: `/v2/m/authorization/request`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createAuthorizationRequestForMobilePath = '/v2/m/authorization/request'
  static createAuthorizationRequestForMobileMethod = 'POST'
}
